// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/projects.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type {
  DenormalizedClient,
  DenormalizedClientJson,
  DenormalizedJobType,
  DenormalizedJobTypeJson,
  DenormalizedUser,
  DenormalizedUserJson,
} from './denormalized_pb';
import { file_proto_v1_denormalized } from './denormalized_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  Address,
  AddressJson,
  AuditUpdater,
  AuditUpdaterJson,
  DateRange,
  DateRangeJson,
  LocationSearch,
  LocationSearchJson,
  Pagination,
  PaginationJson,
  ProjectJobType,
  ProjectJobTypeJson,
  ProjectStakingType,
  ProjectStakingTypeJson,
  ProjectSurveyType,
  ProjectSurveyTypeJson,
  SortDirection,
  SortDirectionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/projects.proto.
 */
export const file_proto_v1_projects: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_denormalized,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetResponse
 */
export type ProjectServiceGetResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
     */
    nameFormat: ProjectNameFormat;

    /**
     * @generated from field: string job_number = 4;
     */
    jobNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
     */
    location?: ProjectLocation;

    /**
     * @generated from field: repeated string clients = 6;
     */
    clients: string[];

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFolder folder = 8;
     */
    folder?: ProjectFolder;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
     */
    flags?: ProjectFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
     */
    surveyTasks?: ProjectSurveyTasks;

    /**
     * @generated from field: map<string, string> attributes = 11;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobType job_types = 12 [deprecated = true];
     * @deprecated
     */
    jobTypes: ProjectJobType[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectServiceDenormalized denormalized = 13;
     */
    denormalized?: ProjectServiceDenormalized;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedJobType job_types_v2 = 14;
     */
    jobTypesV2: DenormalizedJobType[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetResponse
 */
export type ProjectServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
   */
  nameFormat?: ProjectNameFormatJson;

  /**
   * @generated from field: string job_number = 4;
   */
  jobNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
   */
  location?: ProjectLocationJson;

  /**
   * @generated from field: repeated string clients = 6;
   */
  clients?: string[];

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFolder folder = 8;
   */
  folder?: ProjectFolderJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
   */
  flags?: ProjectFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
   */
  surveyTasks?: ProjectSurveyTasksJson;

  /**
   * @generated from field: map<string, string> attributes = 11;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobType job_types = 12 [deprecated = true];
   * @deprecated
   */
  jobTypes?: ProjectJobTypeJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectServiceDenormalized denormalized = 13;
   */
  denormalized?: ProjectServiceDenormalizedJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedJobType job_types_v2 = 14;
   */
  jobTypesV2?: DenormalizedJobTypeJson[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectServiceGetResponseValid = ProjectServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceGetResponse.
 * Use `create(ProjectServiceGetResponseSchema)` to create a new message.
 */
export const ProjectServiceGetResponseSchema: GenMessage<
  ProjectServiceGetResponse,
  {
    jsonType: ProjectServiceGetResponseJson;
    validType: ProjectServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 0);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetRequest
 */
export type ProjectServiceGetRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetRequest
 */
export type ProjectServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetRequest
 */
export type ProjectServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceGetRequest.
 * Use `create(ProjectServiceGetRequestSchema)` to create a new message.
 */
export const ProjectServiceGetRequestSchema: GenMessage<
  ProjectServiceGetRequest,
  {
    jsonType: ProjectServiceGetRequestJson;
    validType: ProjectServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 1);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceCreateRequest
 */
export type ProjectServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceCreateRequest'> & {
    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
     */
    nameFormat: ProjectNameFormat;

    /**
     * @generated from field: string job_number = 4;
     */
    jobNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
     */
    location?: ProjectLocation;

    /**
     * @generated from field: repeated string clients = 6;
     */
    clients: string[];

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
     */
    flags?: ProjectFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
     */
    surveyTasks?: ProjectSurveyTasks;

    /**
     * @generated from field: map<string, string> attributes = 11;
     */
    attributes: { [key: string]: string };
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceCreateRequest
 */
export type ProjectServiceCreateRequestJson = {
  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
   */
  nameFormat?: ProjectNameFormatJson;

  /**
   * @generated from field: string job_number = 4;
   */
  jobNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
   */
  location?: ProjectLocationJson;

  /**
   * @generated from field: repeated string clients = 6;
   */
  clients?: string[];

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
   */
  flags?: ProjectFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
   */
  surveyTasks?: ProjectSurveyTasksJson;

  /**
   * @generated from field: map<string, string> attributes = 11;
   */
  attributes?: { [key: string]: string };
};

export type ProjectServiceCreateRequestValid = ProjectServiceCreateRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceCreateRequest.
 * Use `create(ProjectServiceCreateRequestSchema)` to create a new message.
 */
export const ProjectServiceCreateRequestSchema: GenMessage<
  ProjectServiceCreateRequest,
  {
    jsonType: ProjectServiceCreateRequestJson;
    validType: ProjectServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 2);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceUpdateRequest
 */
export type ProjectServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
     */
    nameFormat: ProjectNameFormat;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
     */
    location?: ProjectLocation;

    /**
     * @generated from field: repeated string clients = 6;
     */
    clients: string[];

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
     */
    flags?: ProjectFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
     */
    surveyTasks?: ProjectSurveyTasks;

    /**
     * @generated from field: map<string, string> attributes = 11;
     */
    attributes: { [key: string]: string };
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceUpdateRequest
 */
export type ProjectServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
   */
  nameFormat?: ProjectNameFormatJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
   */
  location?: ProjectLocationJson;

  /**
   * @generated from field: repeated string clients = 6;
   */
  clients?: string[];

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
   */
  flags?: ProjectFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
   */
  surveyTasks?: ProjectSurveyTasksJson;

  /**
   * @generated from field: map<string, string> attributes = 11;
   */
  attributes?: { [key: string]: string };
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceUpdateRequest
 */
export type ProjectServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
     */
    nameFormat: ProjectNameFormat;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
     */
    location?: ProjectLocationValid;

    /**
     * @generated from field: repeated string clients = 6;
     */
    clients: string[];

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
     */
    flags?: ProjectFlagsValid;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
     */
    surveyTasks?: ProjectSurveyTasksValid;

    /**
     * @generated from field: map<string, string> attributes = 11;
     */
    attributes: { [key: string]: string };
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceUpdateRequest.
 * Use `create(ProjectServiceUpdateRequestSchema)` to create a new message.
 */
export const ProjectServiceUpdateRequestSchema: GenMessage<
  ProjectServiceUpdateRequest,
  {
    jsonType: ProjectServiceUpdateRequestJson;
    validType: ProjectServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 3);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectFolder
 */
export type ProjectFolder = Message<'vmspdb.api.proto.v1.ProjectFolder'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string full_path = 3;
   */
  fullPath: string;

  /**
   * @generated from field: string dropbox_key = 4;
   */
  dropboxKey: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectFolder
 */
export type ProjectFolderJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string full_path = 3;
   */
  fullPath?: string;

  /**
   * @generated from field: string dropbox_key = 4;
   */
  dropboxKey?: string;
};

export type ProjectFolderValid = ProjectFolder;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectFolder.
 * Use `create(ProjectFolderSchema)` to create a new message.
 */
export const ProjectFolderSchema: GenMessage<
  ProjectFolder,
  { jsonType: ProjectFolderJson; validType: ProjectFolderValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 4);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectLocation
 */
export type ProjectLocation = Message<'vmspdb.api.proto.v1.ProjectLocation'> & {
  /**
   * @generated from field: string lot_number = 1;
   */
  lotNumber: string;

  /**
   * @generated from field: string subdivision = 2;
   */
  subdivision: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 3;
   */
  address?: Address;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectTaxLocation tax_location = 4;
   */
  taxLocation: ProjectTaxLocation;

  /**
   * @generated from field: bool no_address = 5;
   */
  noAddress: boolean;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectLocation
 */
export type ProjectLocationJson = {
  /**
   * @generated from field: string lot_number = 1;
   */
  lotNumber?: string;

  /**
   * @generated from field: string subdivision = 2;
   */
  subdivision?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 3;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectTaxLocation tax_location = 4;
   */
  taxLocation?: ProjectTaxLocationJson;

  /**
   * @generated from field: bool no_address = 5;
   */
  noAddress?: boolean;
};

export type ProjectLocationValid = ProjectLocation;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectLocation.
 * Use `create(ProjectLocationSchema)` to create a new message.
 */
export const ProjectLocationSchema: GenMessage<
  ProjectLocation,
  { jsonType: ProjectLocationJson; validType: ProjectLocationValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 5);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectFlags
 */
export type ProjectFlags = Message<'vmspdb.api.proto.v1.ProjectFlags'> & {
  /**
   * @generated from field: bool finalized = 1;
   */
  finalized: boolean;

  /**
   * @generated from field: bool archived = 2;
   */
  archived: boolean;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectFlags
 */
export type ProjectFlagsJson = {
  /**
   * @generated from field: bool finalized = 1;
   */
  finalized?: boolean;

  /**
   * @generated from field: bool archived = 2;
   */
  archived?: boolean;
};

export type ProjectFlagsValid = ProjectFlags;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectFlags.
 * Use `create(ProjectFlagsSchema)` to create a new message.
 */
export const ProjectFlagsSchema: GenMessage<
  ProjectFlags,
  { jsonType: ProjectFlagsJson; validType: ProjectFlagsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 6);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectStaking
 */
export type ProjectStaking = Message<'vmspdb.api.proto.v1.ProjectStaking'> & {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectStakingType description = 1;
   */
  description: ProjectStakingType;

  /**
   * @generated from field: uint32 cost = 2;
   */
  cost: number;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectStaking
 */
export type ProjectStakingJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectStakingType description = 1;
   */
  description?: ProjectStakingTypeJson;

  /**
   * @generated from field: uint32 cost = 2;
   */
  cost?: number;
};

export type ProjectStakingValid = ProjectStaking;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectStaking.
 * Use `create(ProjectStakingSchema)` to create a new message.
 */
export const ProjectStakingSchema: GenMessage<
  ProjectStaking,
  { jsonType: ProjectStakingJson; validType: ProjectStakingValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 7);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTasks
 */
export type ProjectSurveyTasks =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTasks'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyType surveys = 2;
     */
    surveys: ProjectSurveyType[];

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectStaking stakings = 3;
     */
    stakings: ProjectStaking[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTasks
 */
export type ProjectSurveyTasksJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyType surveys = 2;
   */
  surveys?: ProjectSurveyTypeJson[];

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectStaking stakings = 3;
   */
  stakings?: ProjectStakingJson[];
};

export type ProjectSurveyTasksValid = ProjectSurveyTasks;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTasks.
 * Use `create(ProjectSurveyTasksSchema)` to create a new message.
 */
export const ProjectSurveyTasksSchema: GenMessage<
  ProjectSurveyTasks,
  { jsonType: ProjectSurveyTasksJson; validType: ProjectSurveyTasksValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 8);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDenormalized
 */
export type ProjectServiceDenormalized =
  Message<'vmspdb.api.proto.v1.ProjectServiceDenormalized'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedClient clients = 1;
     */
    clients: DenormalizedClient[];

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser managers = 2;
     */
    managers: DenormalizedUser[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDenormalized
 */
export type ProjectServiceDenormalizedJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedClient clients = 1;
   */
  clients?: DenormalizedClientJson[];

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser managers = 2;
   */
  managers?: DenormalizedUserJson[];
};

export type ProjectServiceDenormalizedValid = ProjectServiceDenormalized;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceDenormalized.
 * Use `create(ProjectServiceDenormalizedSchema)` to create a new message.
 */
export const ProjectServiceDenormalizedSchema: GenMessage<
  ProjectServiceDenormalized,
  {
    jsonType: ProjectServiceDenormalizedJson;
    validType: ProjectServiceDenormalizedValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 9);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceCreateResponse
 */
export type ProjectServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
     */
    nameFormat: ProjectNameFormat;

    /**
     * @generated from field: string job_number = 4;
     */
    jobNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
     */
    location?: ProjectLocation;

    /**
     * @generated from field: repeated string clients = 6;
     */
    clients: string[];

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFolder folder = 8;
     */
    folder?: ProjectFolder;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
     */
    flags?: ProjectFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
     */
    surveyTasks?: ProjectSurveyTasks;

    /**
     * @generated from field: map<string, string> attributes = 11;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobType job_types = 12 [deprecated = true];
     * @deprecated
     */
    jobTypes: ProjectJobType[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectServiceDenormalized denormalized = 13;
     */
    denormalized?: ProjectServiceDenormalized;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedJobType job_types_v2 = 14;
     */
    jobTypesV2: DenormalizedJobType[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceCreateResponse
 */
export type ProjectServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
   */
  nameFormat?: ProjectNameFormatJson;

  /**
   * @generated from field: string job_number = 4;
   */
  jobNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
   */
  location?: ProjectLocationJson;

  /**
   * @generated from field: repeated string clients = 6;
   */
  clients?: string[];

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFolder folder = 8;
   */
  folder?: ProjectFolderJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
   */
  flags?: ProjectFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
   */
  surveyTasks?: ProjectSurveyTasksJson;

  /**
   * @generated from field: map<string, string> attributes = 11;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobType job_types = 12 [deprecated = true];
   * @deprecated
   */
  jobTypes?: ProjectJobTypeJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectServiceDenormalized denormalized = 13;
   */
  denormalized?: ProjectServiceDenormalizedJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedJobType job_types_v2 = 14;
   */
  jobTypesV2?: DenormalizedJobTypeJson[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectServiceCreateResponseValid = ProjectServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceCreateResponse.
 * Use `create(ProjectServiceCreateResponseSchema)` to create a new message.
 */
export const ProjectServiceCreateResponseSchema: GenMessage<
  ProjectServiceCreateResponse,
  {
    jsonType: ProjectServiceCreateResponseJson;
    validType: ProjectServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 10);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceUpdateResponse
 */
export type ProjectServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
     */
    nameFormat: ProjectNameFormat;

    /**
     * @generated from field: string job_number = 4;
     */
    jobNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
     */
    location?: ProjectLocation;

    /**
     * @generated from field: repeated string clients = 6;
     */
    clients: string[];

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFolder folder = 8;
     */
    folder?: ProjectFolder;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
     */
    flags?: ProjectFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
     */
    surveyTasks?: ProjectSurveyTasks;

    /**
     * @generated from field: map<string, string> attributes = 11;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobType job_types = 12 [deprecated = true];
     * @deprecated
     */
    jobTypes: ProjectJobType[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectServiceDenormalized denormalized = 13;
     */
    denormalized?: ProjectServiceDenormalized;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedJobType job_types_v2 = 14;
     */
    jobTypesV2: DenormalizedJobType[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceUpdateResponse
 */
export type ProjectServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectNameFormat name_format = 3;
   */
  nameFormat?: ProjectNameFormatJson;

  /**
   * @generated from field: string job_number = 4;
   */
  jobNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectLocation location = 5;
   */
  location?: ProjectLocationJson;

  /**
   * @generated from field: repeated string clients = 6;
   */
  clients?: string[];

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFolder folder = 8;
   */
  folder?: ProjectFolderJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectFlags flags = 9;
   */
  flags?: ProjectFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTasks survey_tasks = 10;
   */
  surveyTasks?: ProjectSurveyTasksJson;

  /**
   * @generated from field: map<string, string> attributes = 11;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobType job_types = 12 [deprecated = true];
   * @deprecated
   */
  jobTypes?: ProjectJobTypeJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectServiceDenormalized denormalized = 13;
   */
  denormalized?: ProjectServiceDenormalizedJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedJobType job_types_v2 = 14;
   */
  jobTypesV2?: DenormalizedJobTypeJson[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectServiceUpdateResponseValid = ProjectServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceUpdateResponse.
 * Use `create(ProjectServiceUpdateResponseSchema)` to create a new message.
 */
export const ProjectServiceUpdateResponseSchema: GenMessage<
  ProjectServiceUpdateResponse,
  {
    jsonType: ProjectServiceUpdateResponseJson;
    validType: ProjectServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 11);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceListRequest
 */
export type ProjectServiceListRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSort sort = 7;
     */
    sort: ProjectSort;

    /**
     * @generated from field: vmspdb.api.proto.v1.LocationSearch location = 6;
     */
    location?: LocationSearch;

    /**
     * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
     */
    dateRange?: DateRange;

    /**
     * load a maximum number of results
     *
     * @generated from field: uint32 load_maximum = 10;
     */
    loadMaximum: number;

    /**
     * @generated from field: bool prefix = 11;
     */
    prefix: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceListRequest
 */
export type ProjectServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSort sort = 7;
   */
  sort?: ProjectSortJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.LocationSearch location = 6;
   */
  location?: LocationSearchJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
   */
  dateRange?: DateRangeJson;

  /**
   * load a maximum number of results
   *
   * @generated from field: uint32 load_maximum = 10;
   */
  loadMaximum?: number;

  /**
   * @generated from field: bool prefix = 11;
   */
  prefix?: boolean;
};

export type ProjectServiceListRequestValid = ProjectServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceListRequest.
 * Use `create(ProjectServiceListRequestSchema)` to create a new message.
 */
export const ProjectServiceListRequestSchema: GenMessage<
  ProjectServiceListRequest,
  {
    jsonType: ProjectServiceListRequestJson;
    validType: ProjectServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 12);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceListResponse
 */
export type ProjectServiceListResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectServiceCreateResponse items = 1;
     */
    items: ProjectServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceListResponse
 */
export type ProjectServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectServiceCreateResponse items = 1;
   */
  items?: ProjectServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type ProjectServiceListResponseValid = ProjectServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceListResponse.
 * Use `create(ProjectServiceListResponseSchema)` to create a new message.
 */
export const ProjectServiceListResponseSchema: GenMessage<
  ProjectServiceListResponse,
  {
    jsonType: ProjectServiceListResponseJson;
    validType: ProjectServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 13);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberRequest
 */
export type ProjectServiceGetNextJobNumberRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberRequest'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberRequest
 */
export type ProjectServiceGetNextJobNumberRequestJson = {};

export type ProjectServiceGetNextJobNumberRequestValid =
  ProjectServiceGetNextJobNumberRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberRequest.
 * Use `create(ProjectServiceGetNextJobNumberRequestSchema)` to create a new message.
 */
export const ProjectServiceGetNextJobNumberRequestSchema: GenMessage<
  ProjectServiceGetNextJobNumberRequest,
  {
    jsonType: ProjectServiceGetNextJobNumberRequestJson;
    validType: ProjectServiceGetNextJobNumberRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 14);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberResponse
 */
export type ProjectServiceGetNextJobNumberResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberResponse'> & {
    /**
     * @generated from field: string job_number = 1;
     */
    jobNumber: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberResponse
 */
export type ProjectServiceGetNextJobNumberResponseJson = {
  /**
   * @generated from field: string job_number = 1;
   */
  jobNumber?: string;
};

export type ProjectServiceGetNextJobNumberResponseValid =
  ProjectServiceGetNextJobNumberResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceGetNextJobNumberResponse.
 * Use `create(ProjectServiceGetNextJobNumberResponseSchema)` to create a new message.
 */
export const ProjectServiceGetNextJobNumberResponseSchema: GenMessage<
  ProjectServiceGetNextJobNumberResponse,
  {
    jsonType: ProjectServiceGetNextJobNumberResponseJson;
    validType: ProjectServiceGetNextJobNumberResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 15);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDeleteResponse
 */
export type ProjectServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceDeleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDeleteResponse
 */
export type ProjectServiceDeleteResponseJson = {};

export type ProjectServiceDeleteResponseValid = ProjectServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceDeleteResponse.
 * Use `create(ProjectServiceDeleteResponseSchema)` to create a new message.
 */
export const ProjectServiceDeleteResponseSchema: GenMessage<
  ProjectServiceDeleteResponse,
  {
    jsonType: ProjectServiceDeleteResponseJson;
    validType: ProjectServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 16);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDeleteRequest
 */
export type ProjectServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDeleteRequest
 */
export type ProjectServiceDeleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceDeleteRequest
 */
export type ProjectServiceDeleteRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceDeleteRequest.
 * Use `create(ProjectServiceDeleteRequestSchema)` to create a new message.
 */
export const ProjectServiceDeleteRequestSchema: GenMessage<
  ProjectServiceDeleteRequest,
  {
    jsonType: ProjectServiceDeleteRequestJson;
    validType: ProjectServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 17);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceSyncResponse
 */
export type ProjectServiceSyncResponse =
  Message<'vmspdb.api.proto.v1.ProjectServiceSyncResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceSyncResponse
 */
export type ProjectServiceSyncResponseJson = {};

export type ProjectServiceSyncResponseValid = ProjectServiceSyncResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceSyncResponse.
 * Use `create(ProjectServiceSyncResponseSchema)` to create a new message.
 */
export const ProjectServiceSyncResponseSchema: GenMessage<
  ProjectServiceSyncResponse,
  {
    jsonType: ProjectServiceSyncResponseJson;
    validType: ProjectServiceSyncResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 18);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceSyncRequest
 */
export type ProjectServiceSyncRequest =
  Message<'vmspdb.api.proto.v1.ProjectServiceSyncRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceSyncRequest
 */
export type ProjectServiceSyncRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectServiceSyncRequest
 */
export type ProjectServiceSyncRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectServiceSyncRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectServiceSyncRequest.
 * Use `create(ProjectServiceSyncRequestSchema)` to create a new message.
 */
export const ProjectServiceSyncRequestSchema: GenMessage<
  ProjectServiceSyncRequest,
  {
    jsonType: ProjectServiceSyncRequestJson;
    validType: ProjectServiceSyncRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_projects, 19);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectNameFormat
 */
export enum ProjectNameFormat {
  /**
   * @generated from enum value: PROJECT_NAME_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_NAME_FORMAT_LOT_NUMBER = 1;
   */
  LOT_NUMBER = 1,

  /**
   * @generated from enum value: PROJECT_NAME_FORMAT_ADDRESS = 2;
   */
  ADDRESS = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectNameFormat
 */
export type ProjectNameFormatJson =
  | 'PROJECT_NAME_FORMAT_UNSPECIFIED'
  | 'PROJECT_NAME_FORMAT_LOT_NUMBER'
  | 'PROJECT_NAME_FORMAT_ADDRESS';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectNameFormat.
 */
export const ProjectNameFormatSchema: GenEnum<
  ProjectNameFormat,
  ProjectNameFormatJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_projects, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectTaxLocation
 */
export enum ProjectTaxLocation {
  /**
   * @generated from enum value: PROJECT_TAX_LOCATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_TAX_LOCATION_CITY = 1;
   */
  CITY = 1,

  /**
   * @generated from enum value: PROJECT_TAX_LOCATION_COUNTY = 2;
   */
  COUNTY = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectTaxLocation
 */
export type ProjectTaxLocationJson =
  | 'PROJECT_TAX_LOCATION_UNSPECIFIED'
  | 'PROJECT_TAX_LOCATION_CITY'
  | 'PROJECT_TAX_LOCATION_COUNTY';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectTaxLocation.
 */
export const ProjectTaxLocationSchema: GenEnum<
  ProjectTaxLocation,
  ProjectTaxLocationJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_projects, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectSort
 */
export enum ProjectSort {
  /**
   * @generated from enum value: PROJECT_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_SORT_JOB_NUMBER = 1;
   */
  JOB_NUMBER = 1,

  /**
   * @generated from enum value: PROJECT_SORT_NAME = 2;
   */
  NAME = 2,

  /**
   * @generated from enum value: PROJECT_SORT_CLIENTS = 3;
   */
  CLIENTS = 3,

  /**
   * @generated from enum value: PROJECT_SORT_JOBS = 4;
   */
  JOBS = 4,

  /**
   * @generated from enum value: PROJECT_SORT_FINALIZED = 5;
   */
  FINALIZED = 5,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectSort
 */
export type ProjectSortJson =
  | 'PROJECT_SORT_UNSPECIFIED'
  | 'PROJECT_SORT_JOB_NUMBER'
  | 'PROJECT_SORT_NAME'
  | 'PROJECT_SORT_CLIENTS'
  | 'PROJECT_SORT_JOBS'
  | 'PROJECT_SORT_FINALIZED';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectSort.
 */
export const ProjectSortSchema: GenEnum<ProjectSort, ProjectSortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_projects, 2);

/**
 * @generated from service vmspdb.api.proto.v1.ProjectService
 */
export const ProjectService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof ProjectServiceCreateRequestSchema;
    output: typeof ProjectServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof ProjectServiceGetRequestSchema;
    output: typeof ProjectServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof ProjectServiceDeleteRequestSchema;
    output: typeof ProjectServiceDeleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.Sync
   */
  sync: {
    methodKind: 'unary';
    input: typeof ProjectServiceSyncRequestSchema;
    output: typeof ProjectServiceSyncResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof ProjectServiceUpdateRequestSchema;
    output: typeof ProjectServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.GetNextJobNumber
   */
  getNextJobNumber: {
    methodKind: 'unary';
    input: typeof ProjectServiceGetNextJobNumberRequestSchema;
    output: typeof ProjectServiceGetNextJobNumberResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof ProjectServiceListRequestSchema;
    output: typeof ProjectServiceListResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_projects, 0);
